module.exports = __webpack_public_path__ + "static/media/f2.9017455a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Feather/f2.png
// module id = 1213
// module chunks = 0